export const getRoomTypeName = (type, lang) => {
  switch (String(type)) { 
    case "1":
      return lang === "th" ? "ห้องมีลูกค้า" : "Occupied Room";
    case "2":
      return lang === "th" ? "ห้องปรับปรุง" : "Under Renovation";
    case "3":
      return lang === "th" ? "ห้องว่าง" : "Vacant Room";
    case "4":
      return lang === "th" ? "ส่วนกลาง" : "Common Area";
    default:
      return "N/A";
  }
};